import { gql } from '@apollo/client';

export type CalendarEventDivisions = {
  id: string;
  name: string;
  program: {
    name: string;
  };
  divisions: {
    id: string;
    name: string;
  }[];
  teams: {
    id: string;
    name: string;
  }[];
};

const QUERY = gql`
  query ShowCalendarEventSeasons($organizationId: Int!, $seasonIds: [ID]) {
    showCalendarEventSeasons(organizationId: $organizationId, seasonIds: $seasonIds) {
      name
      program {
        name
      }
      divisions {
        name
        id
      }
      teams {
        name
        id
      }
    }
  }
`;

export default QUERY;
